import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import './fonts/fonts.css';
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { createMsalConfig } from './config/msal';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ConfigProvider, setGlobalConfig } from './config/ConfigContext';
import { AppConfig } from './config/config';

let persistor: any;
let msalInstance: PublicClientApplication;

// No ejecutar inicialización en entorno de test
if (process.env.NODE_ENV !== 'test') {
  persistor = persistStore(store);
  
  // Cargar configuración primero, luego inicializar MSAL y React
  fetch('/config.json')
    .then(response => {
      if (!response.ok) {
        throw new Error(`Error cargando config.json: ${response.status}`);
      }
      return response.json();
    })
    .then((config: AppConfig) => {
      // Guardar config globalmente para uso fuera de componentes React
      setGlobalConfig(config);
      
      // Crear configuración de MSAL con los valores del ambiente
      const msalConfig = createMsalConfig(config);
      msalInstance = new PublicClientApplication(msalConfig);
      
      return msalInstance.initialize();
    })
    .then(() => {
      // Account selection logic is app dependent. Adjust as needed for different use cases.
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }

      msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
          const payload = event.payload as AuthenticationResult;
          const account = payload.account;
          msalInstance.setActiveAccount(account);
        }
      });

      const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
      );

      root.render(
        <ConfigProvider>
          <BrowserRouter>
            <PersistGate persistor={persistor}>
              <Provider store={store}>
                <App pca={msalInstance} />
              </Provider>
            </PersistGate>
          </BrowserRouter>
        </ConfigProvider>
      );
    })
    .catch(error => {
      console.error('Error inicializando aplicación:', error);
      const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
      );
      root.render(
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          color: '#d32f2f'
        }}>
          <h2>Error inicializando aplicación</h2>
          <p>{error.message}</p>
        </div>
      );
    });
} else {
  // Mock para tests
  msalInstance = {
    getActiveAccount: () => null,
    getAllAccounts: () => [],
    setActiveAccount: () => {},
    addEventCallback: () => {},
    initialize: () => Promise.resolve(),
    acquireTokenSilent: () => Promise.resolve({} as any),
  } as any;
}

export { msalInstance };